import { render, staticRenderFns } from "./NormalButton.vue?vue&type=template&id=6ea59be8&"
import script from "./NormalButton.vue?vue&type=script&lang=js&"
export * from "./NormalButton.vue?vue&type=script&lang=js&"
import style0 from "./NormalButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports